import type {
  DeliveryType,
  DesignStatus,
  OrderChannel,
  OrderStage,
  PaymentMode,
  UserRole,
} from './types';

export const APP_NAME = 'Uncle OMS';

export const ORDER_STAGES: { id: OrderStage; label: string; order: number }[] = [
  { id: 'draft', label: 'Draft', order: 0 },
  { id: 'order_received', label: 'Order Received', order: 1 },
  { id: 'pending_invoice', label: 'Pending Invoice', order: 2 },
  { id: 'invoice_assigned', label: 'Invoice Assigned', order: 3 },
  { id: 'in_fulfillment', label: 'In Fulfillment', order: 4 },
  { id: 'ready_for_dispatch', label: 'Ready for Dispatch', order: 5 },
  { id: 'dispatched', label: 'Dispatched / Installed', order: 6 },
  { id: 'delivered', label: 'Delivered / Completed', order: 7 },
  { id: 'on_hold', label: 'On Hold', order: 0 },
  { id: 'cancelled', label: 'Cancelled', order: 0 },
];

export const DEPARTMENTS = [
  'Management',
  'Sales',
  'Accounts',
  'Design',
  'Production',
  'Finishing',
  'Quality Check',
  'Installation',
  'Logistics',
];

export const ORDER_CHANNELS: { value: OrderChannel; label: string }[] = [
  { value: 'walk_in', label: 'Walk-in' },
  { value: 'phone', label: 'Phone' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'email', label: 'Email' },
  { value: 'referral', label: 'Referral' },
  { value: 'online', label: 'Online' },
  { value: 'other', label: 'Other' },
];

export const DELIVERY_TYPES: { value: DeliveryType; label: string }[] = [
  { value: 'in_store_pickup', label: 'In-Store Pickup' },
  { value: 'local_delivery', label: 'Local Delivery' },
  { value: 'installation_at_site', label: 'Installation at Site' },
  { value: 'courier', label: 'Courier' },
  { value: 'third_party_dispatch', label: 'Third Party Dispatch' },
];

export const PAYMENT_MODES: { value: PaymentMode; label: string }[] = [
  { value: 'cash', label: 'Cash' },
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'upi', label: 'UPI' },
  { value: 'cheque', label: 'Cheque' },
  { value: 'credit', label: 'Credit' },
  { value: 'partial', label: 'Partial' },
  { value: 'tbd', label: 'TBD' },
];

export const DESIGN_STATUSES: { value: DesignStatus; label: string }[] = [
  { value: 'pending_assignment', label: 'Pending Assignment' },
  { value: 'assigned', label: 'Assigned' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'revision_requested', label: 'Revision Requested' },
  { value: 'design_complete', label: 'Design Complete' },
  { value: 'files_print_ready', label: 'Files Print Ready' },
  { value: 'on_hold', label: 'On Hold' },
];

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Admin',
  sales: 'Sales Executive',
  accounts: 'Accounts Executive',
  design_manager: 'Design Manager',
  designer: 'Designer',
  production: 'Production Operator',
  qc: 'QC Executive',
  dispatch: 'Delivery / Dispatch',
};

export const CITIES = ['Mumbai', 'Pune', 'Thane', 'Navi Mumbai', 'Nashik', 'Other'];

export const DEMO_PASSWORD = 'uncle123';

export const IS_PROD = import.meta.env.VITE_PROD === 'true';
